export class EventsService {
  static allEvents: any = {};

  static createEvent(eventName: string, triggerFunction: any, thisArg: object) {
    EventsService.allEvents[eventName] = { triggerFunction, thisArg };
  }
  static triggerEvent(eventName: string, fnArguments?: any) {
    const { triggerFunction, thisArg } = EventsService.allEvents[eventName];
    return triggerFunction.call(thisArg, fnArguments);
  }
}